exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media(min-width: 48em){.error-page__img{width:704px}}", ""]);

